<template>
  <div>
    <el-button type="primary" @click="onlyPrint" size="small"> 打印 </el-button>
    <el-button type="primary" icon="printer" @click="toPdf" size="small"> pdf </el-button>
  </div>
</template>

<script>
import { disAutoConnect } from "vue-plugin-hiprint";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
    panel: String,
    changeList: Array,
  },
  data() {
    return {
      data: {},
      hiprintTemplate: {},
    };
  },
  mounted() {
    this.panel = this.panel || {};
  },
  methods: {
    onlyPrint() {
      disAutoConnect();
      var panel = this.panel || {};
      try {
        panel = JSON.parse(this.panel);
      } catch (err) {}
      this.$print(undefined, panel, this.changeList, {});
    },
    toPdf() {
      this.hiprintTemplate.toPdf(this.printData, "打印预览pdf");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
